import { Skeleton } from "@/app/admin/_common/ui/skeleton";
import GuestTableSkeleton from "@/app/admin/_common/guestlist/GuestTableSkeleton";

export default function FestivalOrdersTabSkeleton() {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-wrap items-center gap-2">
        <Skeleton className="h-[30px] max-w-[320px] flex-1" />
        <Skeleton className="h-[30px] w-[110px]" />
      </div>
      <GuestTableSkeleton showColumn />
    </div>
  );
}
